import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import classes from './AgentAlerts.module.css'
import { Dropdown, Tabs, Tab } from 'react-bootstrap';
import AgentAlertItem from './AgentAlertItem';
import { useTranslation } from "react-i18next"
import { deleteOneMe, updateOneMe } from '../../../../axios/requests/notificationsReq'

const AgentAlerts = (props) => {
    const [t] = useTranslation('common')
    const notificationList = useSelector(state => state.notifications.notificationList)

    const deleteNotificationHandler = useCallback((NotificationId) => {
        deleteOneMe(NotificationId).catch(e => {
            console.log(e)
        })
    }, [])

    const updateNotificationHandler = useCallback((NotificationId, notificationObj) => {
        updateOneMe(NotificationId, notificationObj).catch(e => {
            console.log(e)
        })
    }, [])

    const getNotificationTitle = (notification) => {
        let title = notification.clientName
        if (notification.relatedChat && notification.relatedChat.displayName) {
            title = notification.relatedChat.displayName
        }
        if (notification.relatedChat && notification.relatedChat.crmId && notification.relatedChat.crmId.name) {
            title = notification.relatedChat.crmId.name
        }
        return title
    }

    const getNotificationOnClickRelatedToType = (notification) => {
        switch (notification.notificationType) {
            case 'channel'://chat.clientName, chat.msgType, 2, chat.crmId, false, chat.channelId
                return () => props.onChatNotificationClicked(notification.clientName, notification.msgType, notification.channelId)
            default:
                return null
        }
    }

    const allNotifications = notificationList.map(el => {
        if (new Date(el.notificationTime).getTime() <= Date.now()) {
            return <AgentAlertItem
                key={el._id}
                id={el._id}
                onChatNotificationClicked={props.onChatNotificationClicked}
                title={getNotificationTitle(el)}
                body={el.reason}
                onRejectClicked={updateNotificationHandler}
                onDeleteClicked={deleteNotificationHandler}
                onClick={getNotificationOnClickRelatedToType(el)}
                date={el.notificationTime}
                actionsBtnColor='BLUE'
                iconName={el.msgType} />
        }
        return <AgentAlertItem
            key={el._id}
            id={el._id}
            onChatNotificationClicked={props.onChatNotificationClicked}
            title={getNotificationTitle(el)}
            body={el.reason}
            onRejectClicked={updateNotificationHandler}
            onDeleteClicked={deleteNotificationHandler}
            onClick={getNotificationOnClickRelatedToType(el)}
            date={el.notificationTime}
            iconName={el.msgType} />

    })

    const oldNotifications = notificationList.filter(el => new Date(el.notificationTime).getTime() <= new Date().getTime()).map(el => {
        return <AgentAlertItem
            key={el._id}
            id={el._id}
            onChatNotificationClicked={props.onChatNotificationClicked}
            title={getNotificationTitle(el)}
            body={el.reason}
            onRejectClicked={updateNotificationHandler}
            onDeleteClicked={deleteNotificationHandler}
            onClick={getNotificationOnClickRelatedToType(el)}
            date={el.notificationTime}
            actionsBtnColor='BLUE'
            iconName={el.msgType} />
    })

    const oldNotificationsLength = oldNotifications.length



    return (
        <>
            <Dropdown >
                <Dropdown.Toggle className={`${classes['notification-alert']} ${oldNotifications.length > 0 && classes['notification-alert--toggled']}`}>
                    <i className="fa-solid fa-bell fa-lg ">
                        <label className={`${classes['notification-alert-number']}`}>{oldNotificationsLength}</label>
                    </i></Dropdown.Toggle>
                <Dropdown.Menu className={`${classes.CustomMenu}`}>
                    <Tabs
                        transition={false}
                        id="alert-controlled-tab"
                        className={classes['custom-tabs']}
                    >
                        <Tab tabClassName={classes['custom-tab']} eventKey="current" title={t('current')}>
                            <div className={classes['tab-wrapper']}>
                                {oldNotifications}
                            </div>
                        </Tab>
                        <Tab tabClassName={classes['custom-tab']} eventKey="all" title={t('all notifications')}>
                            <div className={classes['tab-wrapper']}>
                                {allNotifications}
                            </div>
                        </Tab>

                    </Tabs>


                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}

export default AgentAlerts